export const isRecent = (updatedAt?: string, utc?: boolean) => {
  const now = new Date();
  if (updatedAt === undefined) return false;
  const compareTime = 10 * 60 * 1000; //최근 10분 이내의 값인 경우
  return (
    Math.abs(
      now.getTime() -
        (new Date(updatedAt).getTime() + (utc ? 9 * 60 * 60 * 1000 : 0))
    ) <= compareTime
  );
};
